<template lang="pug">
  main
    NavBarAccesos
    Loader(v-show="isLoading")
    ModalDelete(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:eliminar="cancelarEntrada")
    ModalInfo(v-show="modalStatus2" :title="titleModal2" :content="contentModal2" @padre:close="cerrarModal")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half
            h3.title Datos de Verificación
            .field
              label.label Razón Social
              TypeaheadPorteador(:options="porteadores" :optionSelect="itemDataPort" v-model="itemSelPort" :isDisabled="isTH_disabled")
            .field
              label.label Operador
              TypeaheadPorteador(:options="operadores" :optionSelect="itemDataOper" v-model="itemSelOper" :isDisabled="isTH_disabled")
            .field
              label.label Verificador
              .control.has-icons-left.has-icons-right
                input.input.is-primary(
                  type='text', 
                  placeholder='Nombre del Verificador',
                  v-model="verificador",
                  :disabled="true"
                )
                span.icon.is-small.is-left
                  i.fas.fa-user
            .field.is-grouped
              .control
                button.button.is-primary(@click="saveDataVerificacion" v-show="isFormRecAdd")
                  | Guardar
                button.button.is-warning(@click="editDataVerificacion" v-show="isFormRecEdit")
                  | Editar
                button.button.is-info(@click="updateDataVerificacion" v-show="isFormRecUpdate")
                  | Actualizar
                button.button.is-danger(@click="deleteVerificacion" v-show="isFormRecUpdate")
                  | Eliminar
                button.button.is-default(@click="cancelUpdDataVerificacion" v-show="isFormRecUpdate")
                  | Cancelar
          .column.is-half
            .card(v-show="isVisibleFormPG")
              .card-content
                //- .field
                //-   label.label Seleccionar Autotanque
                //-   .control
                //-     .select.is-primary
                //-       select(v-model="autotanqueSelected" @change="getDataPG" :disabled="dataVerificacion")
                //-         option(v-for="data in autotanques" :value="data.pg" :key="data.id")
                //-           | {{ data.pg }}
                TypeaheadPG(:options="autotanquesBD" :optionSelect="itemData" v-model="itemSel")
                .field
                  label.label Transportista
                  .control
                    input.input.is-primary(
                      type='text', 
                      v-model="itemSel.transportista",
                      :disabled="isformPgDisabled"
                    )
                .columns
                  .column.is-half
                    .field
                      label.label ID CRE
                      .control
                        input.input.is-primary(
                          type='text', 
                          v-model="itemSel.idCRE",
                          :disabled="isformPgDisabled"
                        )
                //-   .column.is-half
                //-     .field
                //-       label.label Empresa
                //-       .control
                //-         input.input.is-primary(
                //-           type='text', 
                //-           v-model="itemSel.empresa",
                //-           :disabled="isformPgDisabled"
                //-         )
                .columns
                  .column.is-half
                    .field
                      label.label Placa
                      .control
                        input.input.is-primary(
                          type='text', 
                          v-model="itemSel.placa",
                          :disabled="isformPgDisabled"
                        )
                  .column.is-half
                    .field
                      label.label Capacidad
                      .control
                        input.input.is-primary(
                          type='text', 
                          v-model="itemSel.capacidad",
                          :disabled="isformPgDisabled"
                        )
                button.button.is-warning(@click="editPg" v-show="isformPgEditing")
                  | Editar
                button.button.is-info(@click="updatePg" v-show="isformPgUpdating")
                  | Actualizar
                button.button.is-default(@click="cancelUpdPg" v-show="isformPgUpdating")
                  | Cancelar
              footer.card-footer
                p.card-footer-item
                  span
                    button.button.is-primary(@click="addPg_Full" :disabled="ocupado")
                      | Agregar ✏️
                p.card-footer-item
                  span
                    a.button(@click="deletePG")
                      span.icon
                        i.fas.fa-times
                      span Cancelar
            
            div.panelPgAdds(v-for="pg in autofull" v-show="isVisibleTags")
              //- p(v-show="autofull.length > 0")
              //- AutosRecepcion(v-for="pg in autofull" :auto="pg", @select="deletePG")
              AutosRecepcion(:auto="pg", @select="deletePG")
            br
            button.button.is-primary(@click="goPuntos(idRecepcion)" v-show="isVisibleFinish") Continuar
        .columns.column-blanco
</template> 

<script>
import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'
import moment from 'moment'
import Loader from '@/components/shared/Loader.vue'
import AutosRecepcion from '@/components/sca_Componentes/acceso/AutosRecepcion.vue'
import SelectAutotanque from '@/components/sca_Componentes/acceso/SelectAutotanque.vue'
import TypeaheadPG from '@/components/sca_Componentes/acceso/shared/TypeaheadPG.vue'
import TypeaheadPorteador from '@/components/sca_Componentes/acceso/shared/TypeaheadPorteador.vue'
import NavBarAccesos from '@/components/sca_Componentes/acceso/layout/NavBarAccesos.vue'
import ModalDelete from '@/components/sca_Componentes/acceso/shared/ModalDelete.vue'
import ModalInfo from '@/components/sca_Componentes/acceso/shared/ModalInfo.vue'

import { mapState } from 'vuex'

export default {
  name: 'Agregar',
  components: { Loader, AutosRecepcion, SelectAutotanque, TypeaheadPG, TypeaheadPorteador, NavBarAccesos, ModalDelete, ModalInfo },
  data () {
    return {
      autofull: [],
      autotanquesBD: [],
      porteadores: [],
      operadores: [],
      verificador: '',
      autotanqueSelected: '',
      dataVerificacion: true,
      isformPgDisabled: true,
      isformPgEditing: false,
      isformPgUpdating: false,
      fechaRec: '',
      isformRecepDisabled: false,
      isLoading: false,
      isFormRecAdd: true,
      isFormRecEdit: false,
      isFormRecUpdate: false,
      isVisibleFormPG: false,
      idRecepcion: '',
      idPg_Rec: '',
      selectedPG_del: '',
      selectedPG_add: '',
      userSeguridad: {},
      itemSel: {},
      itemSelPort: {},
      itemSelOper: {},
      itemData: {},
      itemDataPort: {},
      itemDataOper: {},
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      modalStatus2: false,
      contentModal2: '',
      titleModal2: '',
      ocupado: true,
      isVisibleTags: false,
      isVisibleFinish: false,
      isTH_disabled: false
    }
  },
  watch: {
    itemSel () {
      console.log(this.itemSel)
      this.isformPgEditing = true
      autotanquesServicesIRGE.checkPg(this.itemSel.id)
        .then(data => {
          console.log(data)
          if (data.length > 0) {
            console.log('Este Pg no ha salido sigue en la planta')
            this.titleModal2 = 'Autotanque en Planta'
            this.contentModal2 = `El autotanque no se puede agregar, no ha salido de la planta.`
            this.modalStatus2 = true
            this.isLoading = false
            this.ocupado = true
          } else {
            this.ocupado = false
          }
        })
    }
  },
  methods: {
    obtenerPorteadores () {
      autotanquesServicesIRGE.getPorteadores()
        .then(resPort => {
          this.porteadores = resPort
          autotanquesServicesIRGE.getOperadores()
            .then(resOper => {
              console.log(resOper)
              this.operadores = resOper
              this.obtenerAutos()
            })
        })
    },
    saveDataVerificacion () {
      this.isLoading = true
      this.fechaRec = moment().format('YYYY-MM-DD HH:mm:ss')
      let fechaRep = this.obtenerFechaReporte()
      console.log(fechaRep)
      let id = Date.now()
      this.idRecepcion = id
      autotanquesServicesIRGE.addRecepcion(this.idRecepcion, this.fechaRec, fechaRep, this.itemSelPort.id, this.itemSelPort.nombre, this.itemSelOper.id, this.itemSelOper.nombre, this.userSeguridad.id, this.verificador)
        .then(res => {
          if (res.success) {
            this.isLoading = false
            this.isformRecepDisabled = true
            this.isFormRecAdd = false
            this.isFormRecEdit = true
            this.isFormRecUpdate = false
            this.isVisibleFormPG = true
            this.isTH_disabled = true
          } else {
            console.log(res.respuesta)
          }
        })
      this.dataVerificacion = false
    },
    obtenerAutos () {
      autotanquesServicesIRGE.searchPG_All()
        .then(res => {
          console.log(res)
          this.autotanquesBD = res
          this.checarSiExisteRecepcion()
        })
    },
    deletePG () {
      this.autotanqueSelected = ''
      this.transportistaPgSelect = ''
      this.grupoPgSelect = ''
      this.empresaPgSelect = ''
      this.capacidadPgSelect = ''
      this.placaPgSelect = ''
      this.formEditing = ''
      this.isformPgDisabled = true
      this.isformPgEditing = false
      this.isformPgUpdating = false
    },
    addPg_Full () {
      console.log(this.autofull.length)
      console.log(this.autotanques.length)
      // if (this.autofull.length >= 2) {
      if (this.autotanques.length >= 2) {
        console.log('Ya no puede agregar más autotanques')
        this.isVisibleFormPG = false
      } else {
        this.isVisibleFormPG = true
        this.idPg_Rec = Date.now()
        this.isLoading = true
        autotanquesServicesIRGE.addPG_Rec(this.idPg_Rec, this.idRecepcion, this.itemSel.id, this.itemSel.placa)
          .then(res => {
            if (res.success) {
              console.log(res.respuesta)
              let pgAgregado = {
                id: this.idPg_Rec,
                idRec: this.idRecepcion,
                pg: this.itemSel.id,
                placas: this.itemSel.placa,
                verificado: false
              }
              console.log(pgAgregado)
              this.autofull.push(pgAgregado)
              this.$store.commit('addTanque', pgAgregado)
              // this.itemSel.length = 0
              
              this.checkCountPgs()
              this.isLoading = false
            } else {
              console.log(res.respuesta)
            }
          })
      }
    },
    editPg () {
      this.isformPgDisabled = false
      this.isformPgEditing = false
      this.isformPgUpdating = true
    },
    updatePg () {
      this.isLoading = true
      this.isformPgDisabled = true
      this.isformPgEditing = true
      this.isformPgUpdating = false
      autotanquesServicesIRGE.updatePg(this.autotanqueSelected, this.grupoPgSelect, this.placaPgSelect, this.empresaPgSelect, this.transportistaPgSelect, this.capacidadPgSelect)
        .then(res => {
          if (res.success) {
            console.log(res.respuesta)
            this.isformPgEditing = true
            this.isformPgUpdating = false
            this.isformPgDisabled = true
            this.isLoading = false
          } else {
            console.log(res.respuesta)
          }
        })
    },
    cancelUpdPg () {
      this.isformPgDisabled = true
      this.isformPgEditing = true
      this.isformPgUpdating = false
    },
    editDataVerificacion () {
      console.log('Estamos en Editar - posterior a Guardar')
      this.isFormRecAdd = false
      this.isFormRecEdit = false
      this.isFormRecUpdate = true
      this.isTH_disabled = false
    },
    updateDataVerificacion () {
      console.log('Estamos en Update - posterior a Edición')
      this.isFormRecAdd = false
      this.isFormRecEdit = true
      this.isFormRecUpdate = false
      this.isLoading = true
      this.isTH_disabled = true
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    },
    deleteVerificacion () {
      this.titleModal = `Eliminar Verificación.`
      this.contentModal = `🚫 ¿Desea Eliminar la verificación Actual?`
      this.modalStatus = true
    },
    cancelarEntrada (result) {
      if (result === 'delete') {
        this.isLoading = true
        this.modalStatus = false
        autotanquesServicesIRGE.deleteRecepcion(this.idRecepcion)
          .then(data => {
            console.log(data)
            if (data.success) {
              autotanquesServicesIRGE.deletePg_Recepcion(this.idRecepcion)
                .then(res => {
                  if (res.success) {
                    this.isLoading = false
                    this.titleModal2 = 'Recepción Eliminada'
                    this.contentModal2 = `La Recepción se ha Eliminado con Éxito.`
                    this.modalStatus2 = true
                    setTimeout(() => {
                      this.$router.push('/IRGE/Accesos_IRGE')
                    }, 750)
                  } else {
                    this.isLoading = false
                    this.titleModal2 = 'Error al eliminar los PG'
                    this.contentModal2 = res.respuesta
                    this.modalStatus2 = true
                  }
                })
            }
          })
      } else {
        this.modalStatus = false
      }
    },
    cancelUpdDataVerificacion () {
      console.log('Estamos en Editar - posterior a Cancelar Update')
      this.isFormRecAdd = false
      this.isFormRecEdit = true
      this.isFormRecUpdate = false
    },
    deletePG (id) {
      console.log(id)
      this.selectedPG_del = id
      autotanquesServicesIRGE.deletePg_inRecepcion(this.selectedPG_del)
        .then( res => {
          console.log(res)
          if (res.success) {
            console.log('success')
            this.$store.commit('resetTanques')
          } else {
            console.log(res.respuesta)
          }

          var indexOfTanq = this.autofull.findIndex(i => i.id === this.selectedPG_del)
          console.log(indexOfTanq)
          this.autofull.splice(indexOfTanq,1)

          console.log(this.autofull.length)
          switch (this.autofull.length) {
            case 0:
              this.isVisibleTags = false
              this.isVisibleFormPG = true
              break
            case 1:
              this.isVisibleTags = true
              this.isVisibleFinish = true
              this.isVisibleFormPG = true
              this.autofull.forEach(element => {
                this.$store.commit('addTanque', element)
              })
              break
            case 2:
              this.isVisibleTags = true
              this.isVisibleFinish = true
              this.autofull.forEach(element => {
                this.$store.commit('addTanque', element)
              })
              break
          
            default:
              break
          }
        })
      this.itemSel.length = 0
    },
    setSelectedPG_add (id) {
      this.isLoading = true
      console.log(id)
      this.selectedPG_add = id
      setTimeout(() => {
        autotanquesServicesIRGE.searchPG(this.selectedPG_add)
          .then(res => {
            this.transportistaPgSelect = res[0].tranportista
            this.grupoPgSelect = res[0].grupo
            this.empresaPgSelect = res[0].empresa
            this.capacidadPgSelect = res[0].capacidad
            this.placaPgSelect = res[0].placa
            this.isformPgEditing = true
            })
      }, 500)
    },
    goPuntos (id) {
      this.$router.push({ name: 'Lista', params: {id} })
    },
    obtenerFechaReporte () {
      let ahora = moment()
      let ahoraFinal = moment('05:00am', 'h:mma')
      let fechaReporte
      let hoy = moment()
      console.log(ahora)
      console.log(ahoraFinal)
      if (ahoraFinal.isBefore(ahora)) {
        fechaReporte = hoy
      } else {
        fechaReporte = hoy.subtract(1, 'days')
      }
      return fechaReporte.format('YYYY-MM-DD')
    },
    cerrarModal () {
      this.modalStatus2 = false
    },
    checkCountPgs() {
      console.log(this.autofull.length)
      switch (this.autofull.length) {
          case 2:
          this.isVisibleFormPG = false
          this.isVisibleFinish = true
          this.isVisibleTags = true
          break
        case 1:
          this.isVisibleFormPG = true
          this.isVisibleFinish = true
          this.isVisibleTags = true 
          break
        case 0:
          this.isVisibleFormPG = false  
          this.isVisibleFinish = false
          this.isVisibleTags = false
          break
        default:
          break
      }
    },
    checarSiExisteRecepcion () {

      if (Object.keys(this.verificacionActual).length > 0) {
        console.log(this.verificacionActual)
        console.log(this.autotanques)

        this.porteadores.forEach(element => {
          console.log(`${element.id}-${this.verificacionActual.idPort}`)
          if (element.id === this.verificacionActual.idPort) {
            this.itemSelPort = element
            this.itemDataPort = element
          }
        })

        this.operadores.forEach(element => {
          console.log(`${element.id}-${this.verificacionActual.idOperador}`)
          if (element.id === this.verificacionActual.idOperador) {
            this.itemSelOper = element
            this.itemDataOper = element
          }
        })

        this.autotanques.forEach(element => {
          this.autofull.push(element)
        })
        this.isTH_disabled = true
        this.cancelUpdDataVerificacion()
        this.checkCountPgs()
      } else {
        this.isTH_disabled = false
      }
    }
  },
  computed: {
    ...mapState(['userLogin', 'autotanques', 'verificacionActual', 'autotanques'])
  },
  created () {
    this.userSeguridad = Object.assign({}, this.userSeguridad, this.userLogin)
    this.verificador = this.userSeguridad.nombre
    this.obtenerPorteadores()
  }
}
</script>

<style lang="css" scoped>
  .panelPgAdds {
    padding-top: 10px;
  }

  .column-blanco {
    padding-bottom: 100px;
  }

</style>





// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/Agregar.vue